export default class TextVideo {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    const btn = this.el.querySelector('.text-video--video-play')
    if (!btn) return

    btn.addEventListener('click', () => {
      const id = btn.closest('.text-video--video')?.dataset.youtubeId
      if (!id) return

      openVideoModal(id)
    })
  }
}

function getOrCreateVideoModal() {
  let modal = document.querySelector('.text-video-video-modal')
  if (modal) return modal

  modal = document.createElement('div')
  modal.className = 'text-video-video-modal'
  modal.innerHTML = `
    <div class="text-video-video-modal--inner">
      <button type="button" class="text-video-video-modal--close" aria-label="Fermer la vidéo">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L17 17M17 1L1 17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
      <div class="text-video-video-modal--frame">
        <iframe src="" title="Lecteur vidéo YouTube" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </div>
  `
  document.body.appendChild(modal)

  // Le fond (bg-color sur .text-video-video-modal lui-même) ferme au clic,
  // mais uniquement si le clic n'a pas été intercepté par .text-video-video-modal--inner (stopPropagation)
  modal.addEventListener('click', closeVideoModal)
  modal.querySelector('.text-video-video-modal--inner').addEventListener('click', e => e.stopPropagation())
  modal.querySelector('.text-video-video-modal--close').addEventListener('click', closeVideoModal)
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeVideoModal()
  })

  return modal
}

function openVideoModal(youtubeId) {
  const modal = getOrCreateVideoModal()
  modal.querySelector('iframe').src = `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0`
  modal.classList.add('is-open')
  document.body.classList.add('text-video-video-modal-open')
}

function closeVideoModal() {
  const modal = document.querySelector('.text-video-video-modal')
  if (!modal) return

  modal.classList.remove('is-open')
  document.body.classList.remove('text-video-video-modal-open')
  modal.querySelector('iframe').src = ''
}
